import React from "react";
import { FC } from "react";
import { ComponentProps } from "react";
import { Field } from "react-final-form";
import Autocomplete from "../../../../components/Autocomplete";
import useDegreeQueries from "../../hooks/useDegreeQueries";
import { useQuery } from "react-query";
import { useSchoolId } from "../../../school/hooks/useSchoolId";
import { QUERY_KEYS } from "../../../../constants";

const DegreeField: FC<ComponentProps<any>> = React.memo(
  ({ setFirstDegreeAsDefault, withAcademic, ...props }) => {
    const {
      fetchAllFilteredByAcademics,
      fetchAllWithAcademic,
      fetchAllContainingAcademic,
    } = useDegreeQueries();
    const schoolId = useSchoolId();
    const { degrees: degreesQueryKey } = QUERY_KEYS;

    const { isLoading, isFetching, data } = useQuery<any>(
      [degreesQueryKey, schoolId],
      () => {
        if (!schoolId) {
          return fetchAllContainingAcademic();
        }

        if (withAcademic) {
          return fetchAllWithAcademic(schoolId);
        }

        return fetchAllFilteredByAcademics(schoolId);
      },
    );

    const degrees = data?.data;

    return (
      <Field
        defaultValue={setFirstDegreeAsDefault && degrees && degrees[0]}
        loading={(isFetching || isLoading).toString()}
        options={degrees}
        disabled={isLoading || isFetching}
        component={Autocomplete}
        {...props}
      />
    );
  },
);

export default DegreeField;
